<template>
  <el-popover placement="top-start" trigger="hover" v-if="showPopover">
    <div v-html="contentAfter" />
    <small slot="reference" v-html="text" />
  </el-popover>

  <small v-html="text" v-else />
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      default: "",
    },
    number: {
      type: Number,
      default: 10,
    },
    type: {
      type: String,
      default: "",
    },
    // prepend append
    cut: {
      type: String,
      default: "append",
    },
  },
  computed: {
    showPopover() {
      if (this.content == null || this.content === "") {
        return false;
      }
      const con = this.content.replace(/<[^>]+>/g, "");
      if (con.length > this.number) {
        return true;
      } else {
        return false;
      }
    },
    text() {
      if (this.content == null || this.content === "") {
        return null;
      }
      const con = this.content.replace(/<[^>]+>/g, "");
      if (con.length > this.number) {
        if (this.cut === "prepend") {
          return "..." + con.substring(con.length - this.number, con.length);
        } else {
          return con.substring(0, this.number) + "...";
        }
      } else {
        return con;
      }
    },
    contentAfter() {
      if (this.content == null || this.content === "") {
        return null;
      }
      if (this.type === "richText") {
        return this.content;
      } else {
        return this.content.replace(/\n/g, "<br/>");
      }
    },
  },
};
</script>
